import React, { Component } from 'react'
import './CSVLoader.scss'
import { connect } from 'react-redux'

import { Col, Row, Modal } from 'react-bootstrap'

import Card from '../../../components/cards/Card'
import Button from '../../../components/buttons/Button'
import { FilePicker } from 'react-file-picker'
import { loadClientsCSV } from '../../../actions/clients.actions'
import { loadProductsCSV } from '../../../actions/products.actions'
import SweetAlert from 'sweetalert-react'
import { selectUploadResponseClients } from '../../../selectors/clients.selector'
import { selectUploadResponseProducts } from '../../../selectors/products.selector'
import { faDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import { selectSetCurrentCompany } from '../../../selectors/company.selector'
import IconButton from '../../../components/buttons/IconButton'
import { TableV2 } from '../../../components'

const CATEGORY_UPLOAD = {
  CLIENTS: 'CLIENTS',
  PRODUCTS: 'PRODUCTS',
  NONE: 'NONE',
}
const URL_TEMPLATE_CLIENTS =
  'https://firebasestorage.googleapis.com/v0/b/distribution-app-dev.appspot.com/o/file_products.csv?alt=media&token=a7f4a399-2bc6-4518-bb47-a9bb85960800'
const URL_TEMPLATE_PRODUCTS =
  'https://firebasestorage.googleapis.com/v0/b/distribution-app-dev.appspot.com/o/file_products.csv?alt=media&token=a7f4a399-2bc6-4518-bb47-a9bb85960800'

class CSVLoader extends Component {
  state = {
    showError: false,
    showSuccess: false,
    showMessageList: false,
    global: false,
    errorText: '',
    fullResponse: {},
    categoryUpload: CATEGORY_UPLOAD.NONE,
    isLoading: false,
    showInfo: false,
    info: { title: '', content: '' },
  }

  onSuccessLoadFile = (response, isError) => {
    this.setState({ isLoading: false })
    if (!isError) {
      console.log(response)
      this.showInfo(response)
    } else {
      this.setState({
        showSuccess: false,
        showError: true,
        errorText: 'Error al subir el archivo',
        fullResponse: {
          errorColumns: ['Linea', 'Columna', 'Error', 'Descripcion'],
          errors: [],
          items: 0,
          message: 'Error al subir el archivo',
          ok: false,
        },
      })
    }
  }

  showInfo = response => {
    if (response.ok === false) {
      this.setState({
        showSuccess: false,
        showError: true,
        errorText: response.message,
        fullResponse: response,
      })
    } else {
      this.setState({ showSuccess: true, showError: false, fullResponse: response })
    }
  }

  saveClientsCSV = file => {
    const { global } = this.state
    this.setState({ categoryUpload: CATEGORY_UPLOAD.CLIENTS, isLoading: true })
    this.props.uploadClientsCSV(file, global, this.onSuccessLoadFile)
  }

  saveProductsCSV = file => {
    this.setState({ categoryUpload: CATEGORY_UPLOAD.PRODUCTS, isLoading: true })
    this.props.uploadProductsCSV(file, this.onSuccessLoadFile, true)
  }

  getButton = type => {
    return (
      <div>
        <IconButton
          tooltip={'Información'}
          icon={faInfoCircle}
          onClick={() => this.showInfoDownload(type)}
        />
        <a
          download={`Plantilla ${
            type == CATEGORY_UPLOAD.CLIENTS ? 'Clientes' : 'Productos'
          }`}
          href={
            type == CATEGORY_UPLOAD.CLIENTS ? URL_TEMPLATE_CLIENTS : URL_TEMPLATE_PRODUCTS
          }
          style={{ color: 'white' }}>
          {' '}
          <IconButton tooltip={'Descargar Plantilla'} icon={faDownload} />
        </a>
      </div>
    )
  }

  showInfoDownload = type => {
    switch (type) {
      case CATEGORY_UPLOAD.PRODUCTS:
        this.setState({
          info: {
            title: 'Productos',
            content:
              'Los nombres de las columnas deben ser escritos en minúscula y sin tildes.\n' +
              'Las columnas para las cuales no hay información se dejan en blanco\n' +
              "Los valores de la columna 'Transformación automática' pueden ser Si o No",
          },
        })
        break
      case CATEGORY_UPLOAD.CLIENTS:
        this.setState({
          info: {
            title: 'Clientes',
            content:
              'Los nombres de las columnas deben ser escritos en minúscula y sin tildes.\n' +
              'Las columnas para las cuales no hay información se dejan en blanco',
          },
        })
        break
    }
    this.setState({ showInfo: true })
  }

  handleCheckBoxChange = event => {
    const { name, checked } = event.target
    this.setState({ [name]: checked })
  }

  componentDidMount() {
    this.props.getCurrentCompany()
  }

  render() {
    const { showError, errorText, showSuccess, fullResponse, showMessageList, global } =
      this.state
    const { company } = this.props
    const { categoryUpload, isLoading } = this.state
    return (
      <div>
        <Row>
          <Col md={6}>
            <Card
              title={'Carga CSV Clientes'}
              button={this.getButton(CATEGORY_UPLOAD.CLIENTS)}>
              {' '}
              <FilePicker
                maxSize={5}
                extensions={['csv']}
                onChange={this.saveClientsCSV}
                onError={errMsg => this.setState({ showError: true, errorText: errMsg })}>
                <div style={{ paddingTop: 10 }}>
                  <Button
                    loading={isLoading && categoryUpload == CATEGORY_UPLOAD.CLIENTS}
                    disabled={isLoading}
                    className={'big-button no-bottom-margin'}>
                    Cargar Clientes
                  </Button>
                </div>
              </FilePicker>
              <br />
              {company && company.email === 'cotizap@cotizap.com' ? (
                <label className={'checkbox-label'}>
                  <input
                    type="checkbox"
                    name="global"
                    checked={global}
                    onChange={this.handleCheckBoxChange}
                  />{' '}
                  Subir como globales
                </label>
              ) : (
                ''
              )}
            </Card>
          </Col>
          <Col md={6}>
            <Card
              title={'Carga CSV Productos'}
              button={this.getButton(CATEGORY_UPLOAD.PRODUCTS)}>
              {' '}
              <FilePicker
                maxSize={5}
                extensions={['csv']}
                onChange={this.saveProductsCSV}
                onError={errMsg => this.setState({ showError: true, errorText: errMsg })}>
                {' '}
                <div style={{ paddingTop: 10 }}>
                  <Button
                    loading={isLoading && categoryUpload == CATEGORY_UPLOAD.PRODUCTS}
                    disabled={isLoading}
                    className={'big-button no-bottom-margin'}>
                    Cargar Productos
                  </Button>
                </div>
              </FilePicker>
              <br />
            </Card>
          </Col>
        </Row>
        <SweetAlert
          show={showError}
          title="Error"
          text={errorText}
          type={'warning'}
          onConfirm={() => {
            if (fullResponse.errors != undefined) {
              if (fullResponse.errors.length > 0) {
                this.setState({ showMessageList: true })
              }
            }
            this.setState({ showError: false })
          }}
        />
        <SweetAlert
          show={showSuccess}
          title="Cargado con exito"
          text={'Archivo cargado con exito'}
          type={'success'}
          onConfirm={() => {
            if (fullResponse.errors != undefined) {
              if (fullResponse.errors.length > 0) {
                this.setState({ showMessageList: true })
              }
            }
            this.setState({ showSuccess: false })
          }}
        />
        <SweetAlert
          show={this.state.showInfo}
          type={'info'}
          title={this.state.info.title}
          text={this.state.info.content}
          onConfirm={() =>
            this.setState({ showInfo: false, info: { title: '', content: '' } })
          }
        />
        <Modal
          show={showMessageList}
          size="lg"
          centered
          onHide={() => this.setState({ showMessageList: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Detalle de carga</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Durante la carga se encontraron los siguientes errores o detalles</p>
            <TableV2
              headers={[
                {
                  label: 'Línea',
                  show: true,
                  value: ['line'],
                  type: 'text',
                  className: 'mini',
                },
                {
                  label: 'Columna',
                  show: true,
                  value: ['column'],
                  type: 'text',
                  className: 'mini',
                },
                {
                  label: 'Error',
                  show: true,
                  value: ['error'],
                  type: 'text',
                  className: 'mini',
                },
                {
                  label: 'Mensaje',
                  show: true,
                  value: ['message'],
                  type: 'text',
                  className: 'medium',
                },
                { config: true, show: true, label: '', className: 'mini center' },
              ]}
              items={fullResponse.errors}
              mobileAuto
              storageKey={`csvLoader`}
            />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  uploadResponseClients: selectUploadResponseClients(state),
  uploadResponseProducts: selectUploadResponseProducts(state),
  company: selectSetCurrentCompany(state),
})

const mapDispatchToProps = dispatch => ({
  uploadClientsCSV: (file, global, onSuccessLoadFile) =>
    dispatch(loadClientsCSV(file, global, onSuccessLoadFile)),
  uploadProductsCSV: (file, onSuccessLoadFile, model) =>
    dispatch(loadProductsCSV(file, onSuccessLoadFile, model)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CSVLoader)
